// This is a utility script you can run manually to create placeholder posts for each day
// It will help demonstrate the blog's feature of showing empty days in red
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, Timestamp } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDU8CS1ZuROCx7c-IVhnah29-dzKWDc0Q0",
    authDomain: "habbywebsite.firebaseapp.com",
    projectId: "habbywebsite",
    storageBucket: "habbywebsite.firebasestorage.app",
    messagingSenderId: "205641932237",
    appId: "1:205641932237:web:a0e837ac480a06b8c97884",
    measurementId: "G-K6YHLQPWN9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

/**
 * Creates placeholder blog posts for a range of days
 * @param {number} daysInPast - Number of days in the past to create posts for
 * @param {number} daysInFuture - Number of days in the future to create posts for
 */
const createPlaceholderPosts = async (daysInPast = 14, daysInFuture = 7) => {
    try {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Create posts for past days
        for (let i = daysInPast; i >= 0; i--) {
            const date = new Date(today);
            date.setDate(today.getDate() - i);

            // Make every third post have content, the rest empty
            const hasContent = i % 3 === 0;

            const postId = `post_${date.toISOString().split('T')[0]}`;

            // Create the post
            await setDoc(doc(db, 'blogPosts', postId), {
                date: Timestamp.fromDate(date),
                title: hasContent ? `Blog post for ${date.toLocaleDateString()}` : '',
                content: hasContent ? `This is a placeholder post for ${date.toLocaleDateString()}.\n\nIt contains **bold text** and multiple paragraphs.\n\nThis is just a demonstration of the blog's formatting capabilities.` : '',
                imageUrl: hasContent && i % 6 === 0 ? 'https://picsum.photos/800/400' : '',
                updatedAt: Timestamp.fromDate(new Date())
            });

            console.log(`Created ${hasContent ? 'filled' : 'empty'} post for ${date.toLocaleDateString()}`);
        }

        // Create posts for future days
        for (let i = 1; i <= daysInFuture; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);

            const postId = `post_${date.toISOString().split('T')[0]}`;

            // Create empty post for future days
            await setDoc(doc(db, 'blogPosts', postId), {
                date: Timestamp.fromDate(date),
                title: '',
                content: '',
                imageUrl: '',
                updatedAt: Timestamp.fromDate(new Date())
            });

            console.log(`Created empty post for ${date.toLocaleDateString()}`);
        }

        console.log('All placeholder posts created successfully!');
    } catch (error) {
        console.error('Error creating placeholder posts:', error);
    }
};

// You can run this function manually when needed
// createPlaceholderPosts();

export default createPlaceholderPosts; 